import { render, staticRenderFns } from "./FormDetailContents.vue?vue&type=template&id=1bf89735&scoped=true&"
import script from "./FormDetailContents.vue?vue&type=script&lang=js&"
export * from "./FormDetailContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf89735",
  null
  
)

export default component.exports